export const COOKIE_NAME_ACCESS_TOKEN = "access_token";
export const COOKIE_NAME_ACCOUNT_ID = "account_id";
export const WEB_JWT_TYPE = "_web";
export const ADMIN_JWT_TYPE = "_admin";
